// extracted by mini-css-extract-plugin
module.exports = {"tab-content":"tabs_tab-content__1ZcF9","customtab":"tabs_customtab__26ssw","container":"tabs_container__1pMf_","navlink":"tabs_navlink__297Ay"};